import { render, staticRenderFns } from "./ReportGroupEditDialog.vue?vue&type=template&id=f57fbd34"
import script from "./ReportGroupEditDialog.vue?vue&type=script&lang=js"
export * from "./ReportGroupEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports